import React, { Component } from 'react'
import { Button, Modal, ModalBody, ModalHeader, Label, Form, FormGroup, Input } from 'reactstrap'
import PropTypes from 'prop-types'
import { graphql, compose } from 'react-apollo'
import CreatableSelect from '../Wps/CreatableSelect'
import { createOrUpdateLogMutation, InspectionLogDataFetchQuery } from '../EventLog/mutations'
import BlockWithLoader from '../Support/BlockWithLoader'

class DimensionalControlModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      person_id: null,
      weld_failed: '',
      validationErrors: null,
      isSubmitting: false,
      people_list: []
    }
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleSelectValueChange = this.handleSelectValueChange.bind(this)
  }

  static propTypes = {
    createOrUpdateLogMutation: PropTypes.func.isRequired,
    data: PropTypes.object.isRequired,
    isOpened: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    afterSubmit: PropTypes.func.isRequired,
    weld: PropTypes.object.isRequired,
    editData: PropTypes.object
  }

  componentWillMount() {
    this.setState({ weld_failed: this.props.editData ? (this.props.editData.weld_failed || '') : this.props.weld.length })
    if (this.props.editData) {
      this.setState({ person_id: this.props.editData.person && this.props.editData.person.id })
    }
  }

  componentWillReceiveProps(newProps) {
    if (newProps.data && newProps.data.people) {
      this.setState({ people_list: newProps.data.people.list || [] })
    }
    if (newProps.editData && !this.props.editData) {
      this.setState({
        person_id: newProps.editData.person && newProps.editData.person.id,
        weld_failed: newProps.editData.weld_failed || ''
      })
    }
  }

  handleSelectValueChange(person) {
    this.setState({ person_id: person && person.id })
  }

  handleSubmit(event) {
    event.preventDefault()
    const weldFailed = parseInt(this.state.weld_failed)
    if (!this.state.person_id) {
      return this.setState({ validationErrors: [{ weld_no: this.props.weld.no, errors: ['Please select Person'] }] })
    }
    if (!weldFailed || weldFailed <= 0 || weldFailed > this.props.weld.length) {
      return this.setState({ validationErrors: [{ weld_no: this.props.weld.no, errors: [`NOK length must be between 1 and ${this.props.weld.length}`] }] })
    }
    if (this.state.isSubmitting) return

    this.setState({ isSubmitting: true })
    const form_elements = event.target.elements
    const dateValue = form_elements.date.value
    const [datePart, timePart] = dateValue.split('T')
    const [year, month, day] = datePart.split('-')
    const formattedDate = `${day}.${month}.${year} ${timePart || '00:00'}`

    this.props.createOrUpdateLogMutation({
      variables: {
        date: formattedDate,
        note: form_elements.note.value,
        type: 'WlWelds::Logs::DimensionalControl',
        welds_id: [Number(this.props.weld.id)],
        id: this.props.editData ? this.props.editData.id : null,
        person_id: this.state.person_id,
        complete_percent: '100',
        complete: weldFailed,
        weld_failed: weldFailed,
        log_data: '{}'
      }
    }).then(({ data: { createOrUpdateLogs } }) => {
      const logsErrors = []
      createOrUpdateLogs.logs.forEach(obj => {
        if (obj.errors && obj.errors.length > 0) {
          logsErrors.push({ weld_no: obj.weld.no, errors: obj.errors })
        }
      })
      if (logsErrors.length > 0) {
        this.setState({ validationErrors: logsErrors, isSubmitting: false })
      } else {
        this.setState({ isSubmitting: false })
        this.props.afterSubmit(createOrUpdateLogs.logs)
        this.props.onCancel()
      }
    }).catch((error) => {
      console.error('GraphQL mutation error:', error)
      this.setState({
        isSubmitting: false,
        validationErrors: [{ weld_no: this.props.weld.no, errors: [error.message || 'An unexpected error occurred'] }]
      })
    })
  }

  render() {
    if (this.props.data.error) return <div>An unexpected error occurred</div>

    const now = new Date()
    const defaultDate = this.props.editData && this.props.editData.date
      ? (() => {
          const [datePart, timePart] = this.props.editData.date.split(' ')
          const [day, month, year] = datePart.split('.')
          return `${year}-${month}-${day}T${timePart || '00:00'}`
        })()
      : `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}T00:00`

    return (
      <BlockWithLoader loading={this.props.data.loading}>
        <Modal isOpen={this.props.isOpened} backdrop={this.state.isSubmitting ? 'static' : true} keyboard={!this.state.isSubmitting}>
          <ModalHeader>Dimensional Control Not OK</ModalHeader>
          <ModalBody>
            <Form onSubmit={this.handleSubmit}>
              <CreatableSelect
                label="Person"
                id="select-person-dc-nok-form"
                options={this.state.people_list}
                valueKey="id"
                value={this.state.person_id}
                multi={false}
                creatable={false}
                valueChangeFunction={this.handleSelectValueChange}
              />
              <FormGroup>
                <Label>Date</Label>
                <Input
                  name="date"
                  type="datetime-local"
                  defaultValue={defaultDate}
                  required
                />
              </FormGroup>
              <FormGroup>
                <Label>NOK Length (mm)</Label>
                <Input
                  type="number"
                  name="weld_failed"
                  min="1"
                  max={this.props.weld.length}
                  value={this.state.weld_failed}
                  onChange={e => this.setState({ weld_failed: e.target.value })}
                  required
                />
              </FormGroup>
              <FormGroup>
                <Label>Note</Label>
                <Input type="textarea" name="note" />
              </FormGroup>
              {this.state.validationErrors &&
                this.state.validationErrors.map((obj, i) => (
                  <h4 key={i} className="errors-heading">
                    {`Weld No: ${obj.weld_no} -> ${obj.errors.join(', ')}`}
                  </h4>
                ))
              }
              <FormGroup>
                <Button className="float-right" color="danger" onClick={this.props.onCancel} disabled={this.state.isSubmitting}>Cancel</Button>
                <Button className="float-right" color="primary" type="submit" disabled={this.state.isSubmitting}>
                  {this.state.isSubmitting ? 'Saving...' : 'Confirm NOK'}
                </Button>
              </FormGroup>
            </Form>
          </ModalBody>
        </Modal>
      </BlockWithLoader>
    )
  }
}

export default compose(
  graphql(InspectionLogDataFetchQuery, {
    options: {
      fetchPolicy: 'network-only',
      variables: { filters: { permission_key: 'core.people.inspector', active: 'true' } }
    }
  }),
  graphql(createOrUpdateLogMutation, { name: 'createOrUpdateLogMutation' })
)(DimensionalControlModal)



// WEBPACK FOOTER //
// ./src/components/EventLog/DimensionalControlModal.js